module.exports = __webpack_public_path__ + "static/media/group.a0dec0da.png";